module.exports = __webpack_public_path__ + "img/banner2.6b0df425.png";